<template>
  <div v-if="pageCount > 1" class="flex justify-center my-4">
    <dashboard-links-pagination-button
      @click="setPage(page - 1)"
      :disabled="page <= 0"
      class="mx-3"
    >
      &larr;
    </dashboard-links-pagination-button>
    <dashboard-links-pagination-button
      v-for="pageNo in pageCount"
      :key="pageNo"
      @click="setPage(pageNo - 1)"
      :active="pageNo === page + 1"
      class="mx-1"
    >
      {{ pageNo }}
    </dashboard-links-pagination-button>
    <dashboard-links-pagination-button
      @click="setPage(page + 1)"
      :disabled="page >= pageCount - 1"
      class="mx-3"
    >
      &rarr;
    </dashboard-links-pagination-button>
  </div>
</template>

<script>
import DashboardLinksPaginationButton from './DashboardLinksPaginationButton';

export default {
  components: {
    DashboardLinksPaginationButton,
  },
  props: {
    page: Number,
    pageCount: Number,
  },
  methods: {
    setPage(number) {
      this.$emit('change', number);
    },
  },
};
</script>
